export const related = [
  '/puzzles/pulse-fitness',
  '/puzzles/atlantis-code-the-park',
  '/puzzles',
];
export const quickAnswer =
  'Front-left: middle light. Back-left: left light. Back-right: left light. Front-right: middle light.';
export const sourceIds = ['powerpyx-hideouts'];
export const diagram = {
  src: '/diagrams/art-gallery-pillars.svg',
  alt: 'Four pillars: front-left middle, back-left left, back-right left, front-right middle.',
  width: 820,
  height: 500,
};

## Where to Find the Art Gallery

Enter the gallery in Evacuation Zone. Use the entrance as the reference for front and back.

## Correct Pillar Light Pattern

Set each of the four pillars to its matching light:

- Front-left: middle.
- Back-left: left.
- Back-right: left.
- Front-right: middle.

## How to Know It Is Complete

A doorway in the left corner opens. The health-upgrade item is inside the Secret Hideout.

## Puzzle Not Working?

Reorient from the entrance before checking left and right. Count the selected light on each pillar; lighting another pillar correctly will not compensate for a misplaced setting.
